import { useScrollIntoView } from 'modules/authentication';
import React from 'react';
import { useAutoResizeTextarea } from '../hooks';

interface Props {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  helpText?: string;
  maxLength?: number;
  dataCy?: string;
  containerClassName?: string;
  textareaClassName?: string;
}

export const AITextareaField: React.FC<Props> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  helpText,
  maxLength,
  dataCy,
  containerClassName = 'field',
  textareaClassName,
}) => {
  const { handleFocus } = useScrollIntoView();
  const { handleRef } = useAutoResizeTextarea(value);

  return (
    <div className={containerClassName}>
      <label htmlFor={id} className="t-label t-text-2">
        {label}
      </label>
      <div className="s-top--tny">
        <textarea
          id={id}
          ref={handleRef}
          onFocus={handleFocus}
          className={`input input__box input__textarea account-delete-modal__textarea proposal-ai-generator__textarea-field ${
            textareaClassName || ''
          }`}
          placeholder={placeholder}
          data-cy={dataCy}
          rows={1}
          value={value}
          maxLength={maxLength}
          onChange={(event) => onChange(event.target.value)}
        />
      </div>
      {helpText && (
        <p className="field__helptext text--sm t-text-3">{helpText}</p>
      )}
    </div>
  );
};
